import { render, staticRenderFns } from "./NavigationList.vue?vue&type=template&id=20507cb2&"
import script from "./NavigationList.vue?vue&type=script&lang=js&"
export * from "./NavigationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports